import { Link } from 'react-router-dom'
import { Crop, Mail, Github, Heart } from 'lucide-react'
import { useIntl } from 'react-intl'
import { useLanguage } from '../contexts/LanguageContext'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const intl = useIntl()
  const { getLocalizedPath } = useLanguage()

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="p-2 bg-primary-600 rounded-lg">
                <Crop className="h-6 w-6 text-white" />
              </div>
              <span className="text-xl font-display font-bold">
                {intl.formatMessage({ id: 'footer.brand' })}
              </span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              {intl.formatMessage({ id: 'footer.description' })}
            </p>
            <div className="flex space-x-4">
              <a
                href="mailto:contact@avatarcropper.org"
                className="flex items-center space-x-2 text-gray-300 hover:text-primary-400 transition-colors"
              >
                <Mail className="h-5 w-5" />
                <span>{intl.formatMessage({ id: 'footer.contact' })}</span>
              </a>
              <a
                href="https://jpgtoavif.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-300 hover:text-primary-400 transition-colors"
              >
                <Github className="h-5 w-5" />
                <span>{intl.formatMessage({ id: 'footer.jpgToAvif' })}</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{intl.formatMessage({ id: 'footer.quickLinks' })}</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to={getLocalizedPath('/')} 
                  className="text-gray-300 hover:text-primary-400 transition-colors"
                >
                  {intl.formatMessage({ id: 'footer.home' })}
                </Link>
              </li>
              <li>
                <Link 
                  to={getLocalizedPath('/faq')} 
                  className="text-gray-300 hover:text-primary-400 transition-colors"
                >
                  {intl.formatMessage({ id: 'footer.faq' })}
                </Link>
              </li>
              <li>
                <Link 
                  to={getLocalizedPath('/privacy')} 
                  className="text-gray-300 hover:text-primary-400 transition-colors"
                >
                  {intl.formatMessage({ id: 'footer.privacy' })}
                </Link>
              </li>
              <li>
                <a 
                  href="mailto:contact@avatarcropper.org"
                  className="text-gray-300 hover:text-primary-400 transition-colors"
                >
                  {intl.formatMessage({ id: 'footer.contactLink' })}
                </a>
              </li>
            </ul>
          </div>

          {/* Features */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{intl.formatMessage({ id: 'footer.features' })}</h3>
            <ul className="space-y-2 text-gray-300">
              <li>{intl.formatMessage({ id: 'footer.featuresList.free' })}</li>
              <li>{intl.formatMessage({ id: 'footer.featuresList.noRegistration' })}</li>
              <li>{intl.formatMessage({ id: 'footer.featuresList.multipleFormats' })}</li>
              <li>{intl.formatMessage({ id: 'footer.featuresList.mobileFriendly' })}</li>
              <li>{intl.formatMessage({ id: 'footer.featuresList.secure' })}</li>
              <li>{intl.formatMessage({ id: 'footer.featuresList.highQuality' })}</li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-1 text-gray-300 mb-4 md:mb-0">
              <span>{intl.formatMessage({ id: 'footer.madeWith' })}</span>
              <Heart className="h-4 w-4 text-red-500" />
              <span>{intl.formatMessage({ id: 'footer.byTeam' })}</span>
            </div>
            <div className="text-gray-300 text-sm">
              © {currentYear} {intl.formatMessage({ id: 'footer.copyright' })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer